import React, { useEffect, useState } from 'react';
import { Grid, Typography, withStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { CourseTheme } from 'assets/themes/Course';
import { useParams } from 'react-router';
import { lessonParams } from 'interface/lessonParams';
import { fetchRating, sendRating } from 'services/lesson';
import { useAppSelector } from 'hooks/redux';
import { IAuth } from 'interface/auth';
import { hjTagging } from 'utils';
import RatingComponent from '@material-ui/lab/Rating';

const useStyles = makeStyles<CourseTheme>((theme) => ({
  ratingText: {
    color: 'white',
    fontWeight: 400,
    fontSize: 16,
  },
  ratingContainer: {
    [theme.breakpoints.down('md')]: {
      alignItems: 'flex-start',
      paddingLeft: 20,
      paddingTop: 15,
    },
  },
}));

const StyledRating = withStyles((theme) => ({
  iconFilled: {
    color: theme.palette.warning.main,
  },
  root: {
    '& svg': {
      fontSize: 30,
    },
  },
}))(RatingComponent);

const Rating = () => {
  const [rating, setRating] = useState<number>(null);

  const { lessonID } = useParams<lessonParams>();
  const classes = useStyles({});
  const { isAuthenticated } = useAppSelector<IAuth>((state) => state.auth);

  useEffect(() => {
    if (lessonID && isAuthenticated) {
      fetchRating(parseInt(lessonID)).then((data) => setRating(data.user_rating));
    }
  }, [lessonID, isAuthenticated]);

  const handleChange = (event: any, rate: number) => {
    if (rate === null) return;

    setRating(rate);
    sendRating(parseInt(lessonID), rate).then(() => {
      hjTagging('FEZ-AVALIACAO');
    });
  };

  if (rating === null) return null;

  return (
    <Grid
      aria-label='Campo de avaliação de aula'
      className={classes.ratingContainer}
      container
      direction='column'
      alignItems='flex-end'
    >
      <Grid>
        <StyledRating
          name='ratingComponent'
          className={classes.icon}
          value={rating}
          onChange={handleChange}
          size='large'
          id='lesson-rating'
        />
      </Grid>
      <Typography className={classes.ratingText}>Quanto você gostou dessa aula?</Typography>
    </Grid>
  );
};

export default Rating;
